module.exports = __webpack_public_path__ + "assets/img/slat_open4.fdc07588.svg";